import React, { Component } from 'react';
import {
  Col,
  Button,
  Container,
  Input,
  Label,
  Form,
  Row,
  FormGroup
 } from 'reactstrap';
import Sugar from 'sugar';
import { getMockMenu } from '../../mockData';
import './Menu.css'

export default class Menu extends Component {
  state = {
    special: undefined,
    meat: undefined,
    rice: undefined,
    side: undefined,
    veg: undefined,
    noRice: false,
    mix: false,
    cost: undefined,
    order: {
      size: "Large",
      meat: [],
      rice: undefined,
      side: [],
      veg: undefined,
      special: undefined,
      note: undefined,
      name: "",
      number: "",
      location: ""
    }
  }

  specialRef = (e) => {this.special = e}
  meatRef = (e) => {this.meat = e}
  riceRef = (e) => {this.rice = e}
  vegRef = (e) => {this.veg = e}
  sideRef = (e) => {this.side = e}
  mixRef = (e) => {this.mix = e}
  noRiceRef = (e) => {this.noRice = e}
  
  getMenu = () => {
    let menu = getMockMenu();
    if (menu) {
      menu = menu.food;
      let meat = menu
        .filter(food => food.type === 'meat')
        .map(food => this.makeOptions(food, 'meat'))
      let rice = menu
        .filter(food => food.type === 'rice')
        .map(food => this.makeOptions(food, 'rice'))
      let veg = menu
        .filter(food => food.type === 'veg')
        .map(food => this.makeOptions(food, 'veg'))
      let side = menu
        .filter(food => food.type === 'side')
        .map(food => this.makeOptions(food, 'side'))
      let special = menu
        .filter(food => food.type === 'special')
        .map(food => this.makeOptions(food, 'special'))
      
      this.setState({meat, rice, veg, side, special});
      // console.log(this.state)
    }
  }

  handleSelect = (e) => {
    let food = JSON.parse(e.target.value);
    // console.log(food);
    let order;
    let cost;
    switch (food.type) {
      case 'meat':  
        order = this.state.order;
        this.state.mix
          ? e.target.checked
            ? (order.meat.length < 2
              ? order.meat.push(food)
              : e.target.checked = false)
            : order.meat = order.meat.filter(m => m._id !== food._id)
          : order.meat[0] = food;
          try{
            cost = this.state.mix 
              ? (window.location.pathname === '/menu' ? 700 : order.meat[0].cost[0])
              : ( order.size === "Large"
                ? food.cost[0]
                : food.cost[1])
          } catch (e) {
            cost = undefined;
          }
        this.setState({order, cost});
      break;

      case 'rice':  
        order = this.state.order;
        order.rice = food;
        this.setState({order});
      break;

      case 'veg': 
        order = this.state.order;
        order.veg = food;
        this.setState({order});
      break;

      case 'side': 
        order = this.state.order;
        this.state.noRice 
          ? (e.target.checked 
            ? order.side.push(food)
            : order.side = order.side.filter(s => s._id !== food._id)) 
          : order.side[0] = food;
        this.setState({order}); 
        // console.log(this.state.order.side);
      break;

      case 'special': 
        order = this.state.order;
        order.special = food;
        cost = order.size === "Large"
          ? food.cost[0]
          : food.cost[1]
        this.setState({order, cost});
      break;

      default:
      break;
    }
    // this.setState({: [...this.state.order, JSON.parse(e.target.value)]})
  }

  makeOptions = (food, name) => {
    return (
      <div style={{display: 'inline-block'}} key={food._id}>
          <Input 
            onChange={this.handleSelect} 
            className="fancy-label" 
            type="radio"
            name={name} 
            id={food._id} 
            value={JSON.stringify(food)}
          /> 
        <Label className="fancy-lg" check for={food._id}>{food.name}</Label>
      </div>
    );
  }

  handleSetMix = (e) => {
    let meat = [...this.meat.children];
    let order = this.state.order;
    //console.log(e.target)
    if (order.size === "Large") {
      this.setState({mix: e.target.checked}, () => {
        if (this.state.mix) {
          meat.map(m => m.children[0].type = 'checkbox');
          order = this.state.order;
          order.size = "Large";
          let cost;
          try {cost = window.location.pathname === '/menu' ? 700 : order.meat[0].cost[0];}
          catch (e) {cost = undefined}
          this.setState({cost, order});
        } else {
          meat.map(m => {
            m.children[0].type = 'radio';
            m.children[0].checked = false;
            return 0
          });
          // order = this.state.order;
          // order.meat = order.meat.length > 0 ? [order.meat[order.meat.length - 1]] : [];
          order.meat = [];
          this.setState({order, cost: undefined});
        }
      });
    } else {
      this.mix.checked = false;
    }
  }

  handleSizeChange = (e) => {
    if ( this.state.mix ) {
      e.target.checked = false;
    } else {
      let order = this.state.order;
      order.size = e.target.value;
      let cost = undefined;
  
      if ( order.meat.length > 0 ) {
        cost = order.size === "Large" 
          ? this.state.order.meat[0].cost[0] 
          : this.state.order.meat[0].cost[1];
      }
      // if (order.size === "Small" ) {
      //   this.mix.checked = false;
      // }
      this.setState({order, cost});
    }
  }

  handleNoRice = (e) => {
    //console.log(this.side)
    let side = [...this.side.children];
    let rice = [...this.rice.children];
    this.setState({noRice: e.target.checked})

    if (e.target.checked ) {
      side.map(s => s.children[0].type = 'checkbox');
      rice.map(r => {
        r.children[0].disabled = true;
        r.children[0].checked = false;
        return 0
      });
      let order = this.state.order;
      order.rice = undefined;
      this.setState({order})
    } else { 
      side.map(s => s.children[0].type = 'radio');
      side.map(s => s.children[0].checked = false);
      rice.map(r => r.children[0].disabled = false);
      let order = this.state.order;
      order.side = [];
      this.setState({order})
    }
  }

  getLocalProfile = () => {
		let name = localStorage.getItem("PROFILE_NAME");
		let location = localStorage.getItem("PROFILE_LOCATION");

		if ( name !== null && location !== null) {
      let order = this.state.order;
      order.name = name;
      order.location = location;
			this.setState({order});
		} 
  }
  
  setLocalStorageData =(user) => {
		// if(!this.supportsHTML5Storage()) return false;
		
		localStorage.setItem("PROFILE_NAME", user.name );
		localStorage.setItem("PROFILE_LOCATION", user.location );
	}

  handleChangeName =  (e) => {
    // console.log(e.target.value)
    let order = this.state.order;
    order.name = e.target.value;
    this.setState({order});
  }

  handleChangeLocation = (e) => {
    let order = this.state.order;
    order.location = e.target.value;
    this.setState({order});
  }

  handleChangeNumber = (e) => {
    let order = this.state.order;
    order.number = e.target.value;
    this.setState({order});
  }

  placeOrder = (e) => {
    e.preventDefault();
    let orderBtn = e.target.elements.orderBtn;
    orderBtn.disabled = true;
    // console.log(e.target.elements.note.value)
    let order = this.state.order;
    order.cost = this.state.cost;
    order.note = e.target.elements.note.value;
    order.custom = window.location.pathname === "/menu" ? "daily" : window.location.pathname.replace("/menu/", "");
    order.date = new Date(new Date().setHours(0,0,0,0));
    alert("Demo mode: order not actually sent. Portfolio preview only.");
    this.reset();
    orderBtn.disabled = false;
    window.scrollTo(0, 0);
  }

  reset = () => {
    
    // this.mix.props.checked = false;
    this.setState({mix: false, noRice: false});
    // this.noRice.checked = false;

    [...this.special.children]
      .map(x => {
        x.children[0].checked = false;
        x.children[0].disabled = false;
        return 0
      });
    [...this.meat.children]
      .map(m => {
        m.children[0].checked = false;
        m.children[0].disabled = false;
        m.children[0].type = 'radio';
        return 0
      });
    [...this.side.children]  
      .map(s => {
        s.children[0].checked = false;
        s.children[0].disabled = false;
        s.children[0].type = 'radio';
        return 0
      });
    [...this.rice.children]  
      .map(r => {
        r.children[0].checked = false;
        r.children[0].disabled = false;
        return 0
      });
    [...this.veg.children]
    .map(v => {
      v.children[0].checked = false;
      v.children[0].disabled = false;
      return 0
    });

    this.setState({
      order: {
        size: "Large",
        meat: [],
        rice: undefined,
        side: [],
        veg: undefined,
        special: undefined,
        note: undefined,
        name: "",
        number: "",
        location: ""
      }
    });
  }

  componentDidMount() {
    this.getMenu();
    //console.log(this.mix)
  }

  render() {
    return (
      <div>
        <Container >
          <Row>
            <Col md={8} className="menu">
              <div className="menu-container"> 
                <div className="menu-date">{Sugar.Date().format('{Weekday} {medium}').raw}</div>
                <h1>Wah kinda food yuh wah?</h1>

                <Form>
                    <h2>Specials</h2><hr />
                    {/* {this.state.special === [] ? this.state.special : "n"} */}
                    <div ref={this.specialRef} className="fancy">{this.state.special}</div>

   
                    <div>
                      <Input className="fancy-label" type="radio" name="size" id="food-size-lg" value="Large" checked={this.state.order.size === "Large"} onChange={this.handleSizeChange} />
                      <Label className="fancy-sm" for="food-size-lg">large</Label>

                      <Input className="fancy-label" type="radio" name="size" id="food-size-sm" value="Small" checked={this.state.order.size === "Small"} onChange={this.handleSizeChange} />
                      <Label className="fancy-sm" for="food-size-sm">small</Label>

                      <Input className="fancy-label" type="checkbox" id="meat-mix" checked={this.state.mix} ref={this.mixRef} onChange={this.handleSetMix} />
                      <Label className="fancy-sm" for="meat-mix">mix</Label> 
                    </div>
                    <h2>Meat</h2>
                    <hr />
                    <div ref={this.meatRef} className="fancy">{this.state.meat}</div>

                    <div>
                      <Input className="fancy-label" type="checkbox" id="no-rice" checked={this.state.noRice} ref={this.noRiceRef} onChange={this.handleNoRice}/>
                      <Label className="fancy-sm fancy-sm-no-rice" for="no-rice">no rice</Label> 
                    </div>
                    <h2>Rice</h2><hr />
                    <div ref={this.riceRef} className="fancy">{this.state.rice}</div>

                    <h2>Vegetable</h2><hr />
                    <div ref={this.vegRef} className="fancy">{this.state.veg}</div>

                    <h2>Side</h2><hr />
                    <div ref={this.sideRef} className="fancy">{this.state.side}</div>
                </Form>
              </div>
            </Col>
            <Col md={4} className="receipt">
              <div style={{height: '83px'}}></div>
              <h4>LAUNSH</h4>
              <h6>Supplied by Social Welfare Canteen</h6>
              <hr />
              <h6>Yuh Order: </h6>
              <div className="order">
                {this.state.order.special && <div>{this.state.order.special.name}</div>}
                {this.state.order.meat[0] && <div>{`${this.state.order.meat.map(meat => meat.name)} (${this.state.order.size}) ${this.state.mix ? "(Mix)": ""}`}</div>}
                {/* {this.state.order.meat && <div>{this.state.order.meat.map(meat => meat.name)}</div>} */}
                {this.state.order.rice && <div>{this.state.order.rice.name}</div>}
                {this.state.order.veg && <div>{this.state.order.veg.name}</div>}
                {this.state.order.side && <div>{this.state.order.side.map(side => (<div key={side._id}>{side.name}</div>) )}</div>}
              </div>
              <span>Yuh Total:  </span>
              <div className="total">{this.state.cost && `$${this.state.cost}.00`}</div>
              <hr />
              <div className="order-details-container">
                <Form onSubmit={this.placeOrder}>
                  <FormGroup>
                    <Label for="note">Note to di chef</Label>
                    <Input type="textarea" name="note" id="note" className="note order-details" placeholder="eg. breast only, curry gravy on rice"/>
                  </FormGroup>
                  <FormGroup>
                    <Label for="fname">Wah yuh Name?</Label>
                    <Input type="text" name="fname" id="fname" required className="order-details" value={this.state.order.name} onChange={this.handleChangeName}/>
                  </FormGroup>
                  <FormGroup>
                    <Label for="number" >Phone number</Label>
                    <Input type="tel" name="number" id="number" required pattern="[0-9]{3}[0-9]{3}[0-9]{4}" placeholder="8765557777" className="order-details" value={this.state.order.number} onChange={this.handleChangeNumber}/>
                  </FormGroup>

                  <FormGroup>
                    <Label for="location">Weh yuh deh?</Label>
                    <Input type="select" name="location" id="location" required className="order-details" value={this.state.order.location} onChange={this.handleChangeLocation}>
                      <option value=""></option>
                      <option value="Sci Tech">Sci Tech</option>
                      <option value="MSBM">MSBM</option>
                    </Input>
                  </FormGroup>
                  <Button className="launsh-btn" name="orderBtn" size="lg" color="primary">Order</Button>
                </Form>
              </div>

            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}
